import Styles from './ChapterView.scss';

import Template from './ChapterView.hbs';
import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'
import ProgressBar from 'views/components/progressBar/ProgressBar.svelte'
import SectionItemTemplate from './SectionItemTemplate.hbs'
import ContentLabelModel from 'models/ContentLabelModel'

export default class ChapterView extends BaseView {

    initialize() {

        let courseBrandingLogo
        if (this.model.get('course_branding_id')) {
            courseBrandingLogo = Backbone.Collection.course_branding.get(this.model.get('course_branding_id'))?.get('logo_white')
        }

        const contentLabelModel = new ContentLabelModel(null, {layerModel: this.model})

        this.setElement(Template({
            Styles,
            id: this.model.id,
            index: contentLabelModel.get('index'),
            title: contentLabelModel.get('title'),
            name: contentLabelModel.get('name'),
            isNumberless: contentLabelModel.get('isNumberless'),
            background: this.model.get('image'),
            backgroundPos: this.model.get('background_image_position'),
            courseBrandingLogo,
        }))

        this.model.sections.forEach((section) => {
            const sectionItemTemplate = $(SectionItemTemplate({Styles}))

            this.addSvelteChildView(
                sectionItemTemplate.find('.js-content-label'),
                ContentLabel,
                {
                    model: section,
                    link: `/${section.constructor.pluralType}/show/${section.id}`,
                }
            )

            if (ACL.checkRole(ACL.roles.STUDENT)) {
                const progressBarContainer = sectionItemTemplate.find('.js-progress-bar')
                const progressBar = this.addSvelteChildView(progressBarContainer, ProgressBar, {
                    fragments: {
                        blue: section.get('progress')
                    },
                    showLabel: !ISMOBILE,
                    width: ISMOBILE ? 40 : 50
                })

                progressBarContainer.toggle(Number.isFinite(section.get('progress')))
                this.listenTo(section, 'change:progress', (model) => {
                    progressBar.setFragments({
                        blue: section.get('progress')
                    })
                    progressBarContainer.toggle(Number.isFinite(model.get('progress')))
                })
            }
            this.$('.js-sections').append(sectionItemTemplate)
        })

    }

}
